// The brain's screens, each a file of its own (lazyScreen.tsx, 24 Sep 2026): the route table's
// imports in one place, and `preloadScreens`, which the boot asks for at once (main.tsx). One
// object, so a screen added here is preloaded without anyone remembering to list it.
import { lazyScreen } from './lazyScreen.tsx';

const SCREENS = {
  CandidateEntryScreen: lazyScreen(() =>
    import('../screens/CandidateEntryScreen.tsx').then((m) => m.CandidateEntryScreen),
  ),
  CandidateScreen: lazyScreen(() =>
    import('../screens/CandidateScreen.tsx').then((m) => m.CandidateScreen),
  ),
  CandidatesScreen: lazyScreen(() =>
    import('../screens/CandidatesScreen.tsx').then((m) => m.CandidatesScreen),
  ),
  ClientScreen: lazyScreen(() => import('../screens/ClientScreen.tsx').then((m) => m.ClientScreen)),
  // T152: a document of profiles for a client, to download or send.
  ClientDocumentScreen: lazyScreen(() =>
    import('../screens/ClientDocumentScreen.tsx').then((m) => m.ClientDocumentScreen),
  ),
  ContactScreen: lazyScreen(() =>
    import('../screens/ContactScreen.tsx').then((m) => m.ContactScreen),
  ),
  CrmScreen: lazyScreen(() => import('../screens/CrmScreen.tsx').then((m) => m.CrmScreen)),
  // T111: the CRM's fourth tab, people from the team's LinkedIn networks.
  ConnectionsScreen: lazyScreen(() =>
    import('../screens/ConnectionsScreen.tsx').then((m) => m.ConnectionsScreen),
  ),
  ComparisonScreen: lazyScreen(() =>
    import('../screens/ComparisonScreen.tsx').then((m) => m.ComparisonScreen),
  ),
  ConversationScreen: lazyScreen(() =>
    import('../screens/ConversationScreen.tsx').then((m) => m.ConversationScreen),
  ),
  ConversationsScreen: lazyScreen(() =>
    import('../screens/ConversationsScreen.tsx').then((m) => m.ConversationsScreen),
  ),
  MeetingScreen: lazyScreen(() =>
    import('../screens/MeetingScreen.tsx').then((m) => m.MeetingScreen),
  ),
  MeetingsScreen: lazyScreen(() =>
    import('../screens/MeetingsScreen.tsx').then((m) => m.MeetingsScreen),
  ),
  // T129: the meeting notes reader, measured.
  MeetingReaderScreen: lazyScreen(() =>
    import('../screens/MeetingReaderScreen.tsx').then((m) => m.MeetingReaderScreen),
  ),
  // T330: a person kadmon is talent agent for, and their outreach list.
  TalentClientScreen: lazyScreen(() =>
    import('../screens/TalentClientScreen.tsx').then((m) => m.TalentClientScreen),
  ),
  TeamMeetingScreen: lazyScreen(() =>
    import('../screens/TeamMeetingScreen.tsx').then((m) => m.TeamMeetingScreen),
  ),
  ProfileScreen: lazyScreen(() =>
    import('../screens/ProfileScreen.tsx').then((m) => m.ProfileScreen),
  ),
  // T273: Candidates → Proactive, the stage board of roles with no Search.
  ProactiveScreen: lazyScreen(() =>
    import('../screens/ProactiveScreen.tsx').then((m) => m.ProactiveScreen),
  ),
  ProposedScreen: lazyScreen(() =>
    import('../screens/ProposedScreen.tsx').then((m) => m.ProposedScreen),
  ),
  MyListScreen: lazyScreen(() => import('../screens/MyListScreen.tsx').then((m) => m.MyListScreen)),
  ReportsScreen: lazyScreen(() =>
    import('../screens/ReportsScreen.tsx').then((m) => m.ReportsScreen),
  ),
  ResearchRunScreen: lazyScreen(() =>
    import('../screens/ResearchRunScreen.tsx').then((m) => m.ResearchRunScreen),
  ),
  ResearchScreen: lazyScreen(() =>
    import('../screens/ResearchScreen.tsx').then((m) => m.ResearchScreen),
  ),
  SearchScreen: lazyScreen(() => import('../screens/SearchScreen.tsx').then((m) => m.SearchScreen)),
  SearchesScreen: lazyScreen(() =>
    import('../screens/SearchesScreen.tsx').then((m) => m.SearchesScreen),
  ),
  SettingsScreen: lazyScreen(() =>
    import('../screens/SettingsScreen.tsx').then((m) => m.SettingsScreen),
  ),
  // T128: a colleague's profile, from their staff thread's header.
  StaffScreen: lazyScreen(() => import('../screens/StaffScreen.tsx').then((m) => m.StaffScreen)),
};

export const {
  CandidateEntryScreen,
  CandidateScreen,
  CandidatesScreen,
  ClientScreen,
  ContactScreen,
  CrmScreen,
  ConnectionsScreen,
  ClientDocumentScreen,
  ComparisonScreen,
  ConversationScreen,
  ConversationsScreen,
  MeetingReaderScreen,
  MeetingScreen,
  MeetingsScreen,
  TalentClientScreen,
  TeamMeetingScreen,
  ProactiveScreen,
  ProfileScreen,
  ProposedScreen,
  MyListScreen,
  ReportsScreen,
  ResearchRunScreen,
  ResearchScreen,
  SearchScreen,
  SearchesScreen,
  SettingsScreen,
  StaffScreen,
} = SCREENS;

/** Every screen's file, asked for at once — the one drawn first among them. */
export function preloadScreens(): void {
  for (const screen of Object.values(SCREENS)) void screen.preload();
}
